<template>
  <div class="main">
    <el-row>
      <!-- 查询条件 -->
      <el-col class="pagin" ref="query">
        <el-row class="mb5 mt2 ml2">
          <div class="inline-block mr10">
            <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">角色名称:</div>
            <div class="pl4-6 width-200">
              <el-input v-model="formQuery.rolename" size="small" placeholder="角色名称" clearable></el-input>
            </div>
          </div>
          <div class="inline-block mr10">
            <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">状态:</div>
            <div class="pl4-6 width-200">
              <el-select clearable v-model="formQuery.status" placeholder="请选择状态" size="small">
                <el-option v-for="(item, index) in dictStatus" :key="index" :label="item.codeName" :value="item.codeId"></el-option>
              </el-select>
            </div>
          </div>
          <div class="inline-block mr10">
            <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">创建时间:</div>
            <div class="pl4-6 width-200">
              <el-date-picker
                style="width: 205px;"
                :clearable="true"
                v-model="createTimeDate"
                :picker-options="disabledAfterNow"
                size="small"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </div>
          </div>
          <div class="inline-block mr10" v-if="showMore">
            <div class="absolute pr1 py1 h12 color-title" style="position: absolute;">用户级别:</div>
            <div class="pl4-6 width-200">
              <el-select clearable v-model="formQuery.userLevel" placeholder="请选择用户级别" size="small">
                <el-option v-for="(item, index) in dictUserLevel" :key="index" :label="item.codeName" :value="item.codeId"></el-option>
              </el-select>
            </div>
          </div>
          <div class="inline-block mr4">
            <el-button v-if="checkPermission(funcData, 'query')" size="small" type="primary" icon="el-icon-search" @click="onQuery">查找</el-button>
            <el-button v-if="checkPermission(funcData, 'add')" size="small" type="primary" icon="el-icon-plus" @click="onShowAdd">添加</el-button>
          </div>
          <!-- 批量操作按扭 -->
          <el-dropdown v-if="checkPermission(funcData, 'batchRemove,batchEnable,batchDisable')" size="small" type="primary" trigger="click">
            <el-button type="primary" size="small">
              批量操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="checkPermission(funcData, 'batchRemove')" class="px10" @click.native="onBatchRemove">批量删除</el-dropdown-item>
              <el-dropdown-item v-if="checkPermission(funcData, 'batchEnable')" class="px10" @click.native="onBatchEnable">批量启用</el-dropdown-item>
              <el-dropdown-item v-if="checkPermission(funcData, 'batchDisable')" class="px10" @click.native="onBatchDisable">批量禁用</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-link type="primary" @click="showMore=!showMore" style="margin-left:10px;">{{showMore?'收起∧':'展开∨'}}</el-link>
        </el-row>
      </el-col>

      <!-- 表格  -->
      <el-col v-if="!checkPermission(funcData, 'query')" :style="{height: pageHeight,lineHeight: pageHeight}" class="noPer">没有列表查询权限</el-col>
      <el-col v-else>
        <el-table
          ref="table"
          :key="Math.random()"
          v-loading="pageLoading"
          element-loading-text="拼命加载中"
          size="mini"
          stripe
          border
          style="width: 100%"
          :height="pageHeight"
          :data="dataList"
          :header-cell-class-name="onHeaderClass"
          @sort-change="onSortChange"
          @selection-change="onSelectionChange"
          ><!-- :default-sort = "{prop: 'date', order: 'descending'}" -->

          <el-table-column
            v-if="checkPermission(funcData, 'batchRemove,batchEnable,batchDisable')"
            type="selection"
            width="45"></el-table-column>

          <el-table-column align="center" label="序号" type="index"></el-table-column>

          <el-table-column width="148px" align="center" label="操作">
            <template slot-scope="scope">
              <el-button v-if="checkPermission(funcData, 'detail')" size="mini" title="查看" circle type="success" icon="el-icon-document" @click="onDetail(scope.$index, scope.row)"></el-button>
              <el-button v-if="checkPermission(funcData, 'modify')" size="mini" title="编辑" circle type="warning" icon="el-icon-edit" @click="onShowEdit(scope.$index, scope.row)"></el-button>
              <el-button v-if="checkPermission(funcData, 'remove')" size="mini" title="删除" circle type="danger" icon="el-icon-delete" @click="onPageRemove(scope.$index, scope.row)"></el-button>
              <el-button v-if="checkPermission(funcData, 'authorize')" size="mini" title="授权" circle type="primary" icon="el-icon-thumb" @click="onAuthorize(scope.$index, scope.row)"></el-button>
            </template>
          </el-table-column>

          <el-table-column
            show-overflow-tooltip
            prop="rolename"
            label="角色名称"
            sortable="custom"
            >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="userLevel"
            label="用户级别"
            sortable="custom"
            >
            <template slot-scope="scope">
              <el-tag size="small" type="info" v-if="scope.row.userLevel=='0'">{{scope.row.userLevel|dict(dictUserLevel)}}</el-tag>
              <el-tag size="small" type="danger" v-else-if="scope.row.userLevel=='1'">{{scope.row.userLevel|dict(dictUserLevel)}}</el-tag>
              <el-tag size="small" type="success" v-else-if="scope.row.userLevel=='2'">{{scope.row.userLevel|dict(dictUserLevel)}}</el-tag>
              <el-tag size="small" v-else-if="scope.row.userLevel=='3'">{{scope.row.userLevel|dict(dictUserLevel)}}</el-tag>
              <el-tag size="small" type="warning" v-else-if="scope.row.userLevel=='4'">{{scope.row.userLevel|dict(dictUserLevel)}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="status"
            label="状态"
            sortable="custom"
            >
            <template slot-scope="scope">
              <el-switch
                v-if="checkPermission(funcData, 'enable,disable')"
                :disabled="((scope.row.status!='1' && !checkPermission(funcData, 'enable')) || (scope.row.status=='1' && !checkPermission(funcData, 'disable')))"
                style="margin-right: 5px;"
                @change="onSwitch(scope.$index, scope.row)"
                v-model="scope.row.switch"
                active-color="#409eff"
                inactive-color="#dcdfe6">
              </el-switch>
              <el-tag size="small" type="success" v-if="scope.row.status == '1'">{{scope.row.status|dict(dictStatus)}}</el-tag>
              <el-tag size="small" type="danger" v-else>{{scope.row.status|dict(dictStatus)}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="createTime"
            label="创建时间"
            sortable="custom"
            >
          </el-table-column>
        </el-table>
      </el-col>

      <!-- 分页 -->
      <el-col class="pagination">
        <el-pagination
          background
          :current-page="pageParam.pageNo"
          :page-sizes="[30, 50, 100, 200, 500, 1000]"
          @size-change="onSizeChange"
          @current-change="onCurrentChange"
          layout="prev, pager, next, total, jumper, sizes"
          :total="pageTotal">
        </el-pagination>
      </el-col>
    </el-row>

    <!-- 详情弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogDetail" width="700px" top="8vh">
      <template slot="title"><i class="el-icon-document" /> 角色详情</template>
      <el-descriptions class="detail-div" :column="2" size="small" border labelClassName="detail-label" contentClassName="detail-content">
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-user"></i>角色编号</template>
          {{dataDetail.roleId}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-notebook-1"></i>角色名称</template>
          {{dataDetail.rolename}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-top"></i>用户级别</template>
          {{dataDetail.userLevel|dict(dictUserLevel)}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-open"></i>状态</template>
          {{dataDetail.status|dict(dictStatus)}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"><i class="el-icon-time"></i>创建时间</template>
          {{dataDetail.createTime}}
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogDetail=false" size="small">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 添加弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogAdd" width="460px" @closed="onResetForm('formAdd')" top="8vh">
      <template slot="title"><i class="el-icon-document-add" /> 添加角色</template>
      <el-form :model="formAdd" ref="formAdd" :rules="formAddRules" size="small" inline label-width="80px">
        <el-form-item label="角色名称" prop="rolename">
          <el-input class="width-1" v-model="formAdd.rolename" placeholder="请输入角色名称" maxlength="90" show-word-limit clearable></el-input>
        </el-form-item>
        <el-form-item label="用户级别" prop="userLevel">
          <el-select class="width-1" v-model="formAdd.userLevel" placeholder="请选择用户级别" clearable size="small">
            <el-option v-for="(item, index) in dictUserLevel" :key="index" :label="item.codeName" :value="item.codeId"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmitAdd()" size="small">提 交</el-button>
        <el-button @click="dialogAdd=false" size="small">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 编辑弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogModify" width="460px" @closed="onResetForm('formEdit')" top="8vh">
      <template slot="title"><i class="el-icon-edit" /> 编辑角色</template>
      <el-form :model="formEdit" ref="formEdit" :rules="formEditRules" size="small" inline label-width="80px">
        <el-form-item label="角色名称" prop="rolename">
          <el-input class="width-1" v-model="formEdit.rolename" placeholder="请输入角色名称" maxlength="90" show-word-limit clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmitEdit()" size="small">提 交</el-button>
        <el-button @click="onResetEdit" size="small">重 置</el-button>
      </div>
    </el-dialog>

    <!-- 授权弹窗 -->
    <el-dialog :close-on-click-modal="false" title="角色授权" :visible.sync="dialogAuth" width="600px" @closed="onResetForm('formAuth');">
      <el-form v-loading="loadingAuth" :model="formAuth" ref="formAuth" :rules="formAuthRules" size="mini">
        <el-form-item label="选择权限" prop="authFlag" label-width="120px">
          <el-tree
            :key="Math.random()"
            ref="authTree"
            :data="treeData"
            show-checkbox
            node-key="id"
            :default-checked-keys="checkedList"
            :props="defaultProps"
            ></el-tree>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer" v-show="!loadingAuth">
        <el-button type='primary' @click="onSubmitAuth()" size="small">提 交</el-button>
        <el-button @click="dialogAuth=false" size="small">关 闭</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import axios from 'axios' // 引入页面处理

export default {
  name: 'userplatAuthRole',
  data () {
    return {
      menuName: 'userplatAuthRole',
      dialogAuth: false, // 权限对话框
      loadingAuth: false, // 加载权限
      formQuery: { // 查询对象
        rolename: '', // 角色名称
        status: '', // 状态
        createTimeBegin: '', // 创建时间-开始时间
        createTimeEnd: '', // 创建时间-结束时间
        userLevel: '' // 用户级别
      },
      formAdd: { // 新增对象
        rolename: '', // 角色名称
        userLevel: '' // 用户级别
      },
      formAuth: {}, // 授权对象
      // 权限
      treeData: [],
      defaultProps: {
        children: 'childTree',
        label: 'name'
      },
      checkedList: [],
      formAddRules: { // 新增规则
        rolename: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
        userLevel: [{ required: true, message: '请输入用户级别', trigger: 'blur' }]
      },
      formEditRules: { // 更新规则
        rolename: [{ required: true, message: '请输入角色名称', trigger: 'blur' }]
      },
      formAuthRules: { // 权限规则
      },
      dictUserLevel: [], // 用户级别
      dictStatus: [], // 状态
      idName: 'roleId',
      httpUrl: '/auth/role',
      httpUri: {
      }
    }
  },
  mounted () {
    this.getSysDict('USERPLAT_USER_LEVEL', 'dictUserLevel', 'getUserLevel')
    this.getSysDict('STATUS_TYPE', 'dictStatus', 'getStatus')
  },
  methods: {
    async onAuthorize (index, row) {
      this.loadingAuth = true
      this.dialogAuth = true
      this.formAuth = Object.assign({}, row)
      this.checkedList = await this.getCurrAuth(row.roleId)
      this.treeData = await this.getAuthTree()
      this.loadingAuth = false
    },
    onSubmitAuth () {
      axios({
        url: this.pageUrl + '/authorize',
        method: 'post',
        data: {
          roleId: this.formAuth.roleId,
          resIdList: this.$refs.authTree.getCheckedKeys().concat(this.$refs.authTree.getHalfCheckedKeys())
        }
      }).then(res => {
        if (res.data.code === '0000') {
          this.$message.success(res.data.message)
          this.dialogAuth = false
        }
      }).catch(err => {
        console.log(err, 'onSubmitAuth')
      })
    },
    getAuthTree () {
      return new Promise((resolve, reject) => {
        axios({
          url: this.baseUrl + '/menuFunc',
          method: 'get'
        }).then(res => {
          if (res.data.code === '0000') {
            resolve(res.data.data)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    getCurrAuth (roleId) {
      return new Promise((resolve, reject) => {
        axios({
          url: this.pageUrl + '/resList/' + roleId,
          method: 'get'
        }).then(res => {
          if (res.data.code === '0000') {
            resolve(res.data.data)
          }
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}
</script>

<style scoped>
@import "../../assets/page.css";

</style>
